import makeHttpRequest from '../helpers/ajax';

const getOemAPIURL = () => {
    return WP_OEM_APIURL;
};

const requestData = (url, storageKey) => {
    const request = {
        url,
        expTime: 15 * 60 * 1000,
        storageKey,
        headers: {
            'x-requested-with': 'XMLHttpRequest',
        },
    };
    return request;
};

const getOEMYearList = (carType, make) => {
    const url = `${getOemAPIURL()}GetYears/${carType}/${make}`;
    const storageKey = `GetYears_${carType}_${make}`;
    const request = requestData(url, storageKey);
    return makeHttpRequest(request).then(response => JSON.parse(response).sort(), (error) => {
        console.warn(`There is some issue with network call, please try again${error}`);
    });
};

const getMarketValues = (trim, zipCode) => {
    const storageKey = `GetMarketValues_${trim}_${zipCode}`;
    const url = `${getOemAPIURL()}GetMarketValues/${trim}/${zipCode}`;
    const request = requestData(url, storageKey);
    return makeHttpRequest(request).then(response => JSON.parse(response), (error) => {
        console.warn(`There is some issue with network call, please try again${error}`);
    });
};

const getTrims = (model) => {
    const storageKey = `GetTrims_${model}`;
    const url = `${getOemAPIURL()}GetTrims/${model}`;
    const request = requestData(url, storageKey);
    return makeHttpRequest(request).then(response => JSON.parse(response), (error) => {
        console.warn(`There is some issue with network call, please try again${error}`);
    });
};

const getTrimDetails = (trim) => {
    const storageKey = `GetTrimDetails_${trim}`;
    const url = `${getOemAPIURL()}GetTrimDetails/${trim}`;
    const request = requestData(url, storageKey);
    return makeHttpRequest(request).then(response => JSON.parse(response), (error) => {
        console.warn(`There is some issue with network call, please try again${error}`);
    });
};

const getModelsList = (carType, make, year) => {
    const storageKey = `GetModels_${make}_${carType}_${year}`;
    const url = `${getOemAPIURL()}GetModels/${make}/${carType}/${year}`;
    const request = requestData(url, storageKey);
    return makeHttpRequest(request).then(
        response => JSON.parse(response),
        (error) => {
            console.warn(`There is some issue with network call, please try again${error}`);
        },
    );
};

const getPrices = (trim) => {
    const storageKey = `GetPrices_${trim}`;
    const url = `${getOemAPIURL()}GetPrices/${trim}`;
    const request = requestData(url, storageKey);
    return makeHttpRequest(request).then(response => JSON.parse(response), (error) => {
        console.warn(`There is some issue with network call, please try again${error}`);
    });
};

export {
    getOEMYearList,
    getModelsList,
    getTrimDetails,
    getMarketValues,
    getTrims,
    getPrices,
};
